import http, { handleApiResponse, checkResponse } from '@/services/http'
import ApiResponse from '@/models/ApiResponse'
import PowerBIResponse from '../models/PowerBIResponse'
import Report from "../models/Report";

export default class PowerBIApi {
    static async get(reportID: string, paramId?: number): Promise<PowerBIResponse> {
        const response = await http
            .get<ApiResponse<PowerBIResponse>>(`powerbi/report/${reportID}/${paramId}`)
        return handleApiResponse(response)
    }

    static getAll(): Promise<PowerBIResponse[]> {
        return http
            .get<ApiResponse<PowerBIResponse[]>>(`powerbi/reports`)
            .then(handleApiResponse)
    }

    static getAllByType(reportType: number): Promise<Report[]> {
        return http.get<ApiResponse<Report[]>>(`powerbi/reports/type/${reportType}`)
            .then(handleApiResponse);
    }    
}